import {
  ItemDetailPageModel,
  ProductAttributeInputModel,
  PricingPageInputModel,
  RelatedSectionModel,
  PurchaseLinkGridModel,
  PurchaseLinkModel,
  CountryWithStateModel,
} from "../../../../shared/models";
import React, { useEffect, useState } from "react";
import BlueDots from "../../../../../../../images/common/blue-dots.svg";
import CheckoutIcon from "../../../../../../../images/common/link-blue.svg";
import EditIcon from "../../../../../../../images/products/edit-blue.svg";
import DeleteIcon from "../../../../../../../images/products/trash-blue.svg";
import ActiveLinkIcon from "../../../../../../../images/sidebar/link-royal-blue.svg";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import styled from "styled-components";
import {
  ActiveInactiveButton,
  AuthService,
  CustomLabel,
  FlexContainer,
  ITableHeaders,
  Loader,
  TableWithHeaderButtons,
  ToastService, 
  withRouter,
} from "@mindmemobile/mm-shared-global";
import PurchaseLinkPopUp from "../../../PurchaseLinkPopUp";
import {
  PurchaseLinkStore,
  RolesAndPermissionStore,
} from "../../../../shared/store";
import {  PurchaseLinkService } from "../../../../shared/services";
import { SystemItemTypes } from "../../../../shared/enums";
import {
  PlaceholderSmallerGrid,
  TableGrid,
} from "../../../../shared/components";
import DeletePurchaseLinkPopUp from "../../../purchase-link/components/DeletePurchaseLinkPopUp";

type IProps = {
  itemDetails: ItemDetailPageModel;
  pricingInputs?: PricingPageInputModel[] | null;
  relatedSectionData?: RelatedSectionModel;
  purchaseLinkStore: PurchaseLinkStore;
  itemType: string;
  variants?: ProductAttributeInputModel;
  itemId: string;
  isTrackInventory?: boolean;
  navigate: NavigateFunction;
  rolesAndPermissionStore: RolesAndPermissionStore;
  countriesWithState: CountryWithStateModel[];
};

const ItemPurchaseLinkGrid: React.FC<IProps> = ({
  itemDetails,
  pricingInputs,
  relatedSectionData,
  purchaseLinkStore,
  itemType,
  variants,
  itemId,
  isTrackInventory,
  navigate,
  rolesAndPermissionStore,
  countriesWithState
}) => {
  const [showLoader, setShowLoader] = React.useState(true);
  const [showEditPopup, setShowEditPopup] = React.useState(false);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [deletePopup, setDeletePopup] = useState({
    show: false,
    purchaseLinkId: "",
  });

  useEffect(() => {
    loadData(
      purchaseLinkStore.pagination.pageNumber,
      purchaseLinkStore.pagination.pageSize,
      "",
      "name"
    );
  }, []);

  function loadData(
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    sortColumn: string
  ) {
    PurchaseLinkService.getPurchaseLinksGridData(
      AuthService.authData.accountId,
      itemId,
      itemType,
      pageNumber,
      pageSize,
      sortColumn,
      searchValue
    ).subscribe({
      next: (response) => {
        setShowLoader(false);
        purchaseLinkStore.deserializeAPIResponse(
          response.result || [],
          response.meta
        );
      },
    });
  }

  function onPaginationChange(pageNumber: number, pageSize: number) {
    loadData(pageNumber, pageSize, "", "name");
  }

  function goToDetailPage(id: string) {
    navigate(`/app/purchase-link/detail/${id}`);
  }

  const handleEdit = (data: PurchaseLinkGridModel) => {
    // setShowLoader(true);
    PurchaseLinkService.getPurchaseLink(
      AuthService.authData.accountId,
      data.id
    ).subscribe({
      next: (response) => {
        const mappedData = PurchaseLinkModel.deserializeAPIResponse(
          response.result
        );
        purchaseLinkStore.updatePurchaseLink(mappedData);
        setShowLoader(false);
        setShowEditPopup(true);
      },
      error: () => setShowLoader(false),
    });
  };

  const handleDelete = (data: PurchaseLinkGridModel) => {
    setDeletePopup({ show: true, purchaseLinkId: data.id });
  };

  const handleCopyClick = (url: string, id: string) => {
    const fullURL = `${url}/app/purchase/purchase-link/${id}`;
    navigator.clipboard
      .writeText(fullURL)
      .then(() => {
        ToastService.showSuccess("Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const handleLinkClick = (baseUrl: string, id: string) => {
    const fullURL = `${baseUrl}/app/purchase/purchase-link/${id}`;
    window.open(fullURL, "_blank");
  };

  function columns() {
    const columns: ITableHeaders<PurchaseLinkGridModel>[] = [
      {
        dataKey: "status",
        title: "Status",
        onCellRender: (data: PurchaseLinkGridModel) => {
          return (
            <ActiveInactiveButton
            //  minWidth="70px"
            >
              {data.status}
            </ActiveInactiveButton>
          );
        },
      },
      {
        dataKey: "name",
        title: "Name",
        className: "table-col-25",
        cellClassName: "table-col-25",
        onCellRender: (data: PurchaseLinkGridModel) => {
          return <CustomLabel>{data.name}</CustomLabel>;
        },
      },
      {
        dataKey: "name",
        title: "Link",
        className: "table-col-25",
        cellClassName: "table-col-25",
        onCellRender: (data: PurchaseLinkGridModel) => {
          return (
            <CustomLabel
              onClick={(e) => {
                e.stopPropagation();
                handleLinkClick(data.purchaseBaseURL, data.id);
              }}
              className="link-text"
              color="#556bb8"
            >
              Purchase Link
            </CustomLabel>
          );
        },
      },
      // {
      //   dataKey: "totalViews",
      //   title: "Total Views",
      //   className: "table-col-10",
      //   cellClassName: "table-col-10",
      //   onCellRender: (data: PurchaseLinkGridModel) => {
      //     return <CustomLabel>{data.totalViews}</CustomLabel>;
      //   },
      // },
      {
        dataKey: "createdDate",
        title: "Created Date",
        className: "table-col-20",
        cellClassName: "table-col-20",
        onCellRender: (data: PurchaseLinkGridModel) => {
          return <CustomLabel>{data.createdDate}</CustomLabel>;
        },
      },
      {
        dataKey: "lastPurchase",
        title: "Last Purchase",
        className: "table-col-15",
        cellClassName: "table-col-15",
        onCellRender: (data: PurchaseLinkGridModel) => {
          return <CustomLabel>{data.lastPurchase}</CustomLabel>;
        },
      },
      {
        dataKey: "lastPurchase",
        title: "Actions",
        className: "table-col-10 text-center",
        cellClassName: "table-col-10 text-center",
        onCellClick: (e) => {
          e.stopPropagation();
        },
        onCellRender: (data: PurchaseLinkGridModel) => {
          return (
            <FlexContainer
              alignItems="center"
              justifyContent="center"
              spacing={10}
            >
              <img
                alt="edit"
                src={EditIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!rolesAndPermissionStore.hasManagePermission("Edit"))
                    return;
                  handleEdit(data);
                }}
                className="img-15 clickable"
              />
              <img
                alt="copy"
                src={ActiveLinkIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyClick(data.purchaseBaseURL, data.id);
                }}
                className="img-15 clickable"
              />
              <img
                alt="delete"
                src={DeleteIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!rolesAndPermissionStore.hasManagePermission("Delete"))
                    return;
                  if (data.isDefault) return;
                  handleDelete(data);
                }}
                style={{ opacity: data.isDefault ? "0.5" : "1" }}
                className="img-15 clickable"
              />
            </FlexContainer>
          );
        },
      },
    ];
    return columns;
  }

  const handleNewButtonClick = () => {
    if (!rolesAndPermissionStore.hasManagePermission("Create")) return;
    purchaseLinkStore.copySelectedItemDetails(
      itemDetails,
      pricingInputs?.map((price) => new PricingPageInputModel(price)) || null,
      relatedSectionData ? new RelatedSectionModel(relatedSectionData) : null,
      itemType as keyof typeof SystemItemTypes,
      variants ? new ProductAttributeInputModel(variants) : null,
      itemId,
      isTrackInventory || false
    );
    setIsPopUpOpen(true);
  };

  const onClosePopUp = (isEdit: boolean = false) => {
    loadData(
      purchaseLinkStore.pagination.pageNumber,
      purchaseLinkStore.pagination.pageSize,
      "",
      "name"
    );
    setIsPopUpOpen(false);
    if (isEdit) {
      setShowEditPopup(false);
    }
    purchaseLinkStore.resetPurchaseLink();
  };

  if (showLoader) {
    return <> {new Loader(true).loaderComponent}</>;
  }

  if (purchaseLinkStore.gridData.length == 0)
    return (
      <>
        <PlaceholderSmallerGrid
          title="No Purchase Links"
          icon={CheckoutIcon}
          buttonCaption="New"
          disableButton={false}
          buttonClick={() => handleNewButtonClick()}
        />
        {isPopUpOpen && (
          <PurchaseLinkPopUp
            purchaseLinkStore={purchaseLinkStore}
            onClose={() => onClosePopUp()}
          />
        )}
      </>
    );

  const toggleDeletePopup = (refresh: boolean) => {
    setDeletePopup({ show: false, purchaseLinkId: "" });
    if (refresh) {
      loadData(
        purchaseLinkStore.pagination.pageNumber,
        purchaseLinkStore.pagination.pageSize,
        "",
        "name"
      );
    }
  };

  return (
    <>
      <TableGrid
        wrapperClassName="table-with-header-btns"
        data={purchaseLinkStore.gridData}
        headers={columns()}
        tableHeader={
          <TableWithHeaderButtons
            icon={CheckoutIcon}
            title="Purchase Link"
            totalItems={purchaseLinkStore.gridData.length}
            isShowHeaderButton={true}
            showRecentButton={false}
            onNewButtonClick={handleNewButtonClick}
          />
        }
        cellSpacing={20}
         countriesWithState={countriesWithState}
        onRowClick={(data: PurchaseLinkGridModel) => goToDetailPage(data.id)}
        onPaginationChange={(pageNumber: number, pageSize: number) =>
          onPaginationChange(pageNumber, pageSize)
        }
        //pagination={purchaseLinkStore.pagination}
        totalItemCount={purchaseLinkStore.gridData.length}
      />
      {isPopUpOpen && (
        <PurchaseLinkPopUp
          purchaseLinkStore={purchaseLinkStore}
          onClose={() => onClosePopUp()}
        />
      )}
      {showEditPopup && (
        <PurchaseLinkPopUp
          purchaseLinkStore={purchaseLinkStore}
          onClose={() => onClosePopUp(true)}
          isEdit={true}
        />
      )}
      {deletePopup.show && (
        <DeletePurchaseLinkPopUp
          onClose={(refresh: boolean) => toggleDeletePopup(refresh)}
          id={deletePopup.purchaseLinkId}
        />
      )}
    </>
  );
};

export default withRouter(observer(ItemPurchaseLinkGrid));
